import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

import {
  Company,
  Deal,
  EntityType,
  EntityTypeSupportingSourceTracking,
  Person,
} from "@mapmycustomers/shared/types/entity";
import User from "@mapmycustomers/shared/types/User";

import ListModalForCharts from "@app/component/ListModalForCharts";
import { SupportedSources } from "@app/enum/SourceType";
import ChartType from "@app/scene/home/enum/ChartType";
import { getRecordsBySourceList, getTotalrecordsBySourceList } from "@app/scene/home/store";
import { fetchRecordsBySourceForSelectedType } from "@app/scene/home/store/actions";
import { RootState } from "@app/store/rootReducer";

interface Props {
  chartType: ChartType.SOURCE;
  dateRange: string;
  fetchRecordsBySourceForSelectedType: typeof fetchRecordsBySourceForSelectedType.request;
  onHide: () => void;
  pageSize: number;
  recordsBySourceListData: Array<Company | Deal | Person>;
  recordTypes: Exclude<EntityTypeSupportingSourceTracking, EntityType.ACTIVITY>[];
  sourceType?: SupportedSources;
  title?: React.ReactNode;
  totalRecords: number;
  users: User[];
}

const RecordListBySourceModal: React.FC<Props> = ({
  chartType,
  dateRange,
  fetchRecordsBySourceForSelectedType,
  onHide,
  pageSize,
  recordsBySourceListData,
  recordTypes,
  sourceType,
  title,
  totalRecords,
  users,
}) => {
  const [page, setPage] = useState<number>(1);
  useEffect(() => {
    if (sourceType) {
      fetchRecordsBySourceForSelectedType({
        dateRange,
        entityTypes: recordTypes,
        page,
        sourceType,
        userId: users.map(({ id }) => id),
      });
    }
  }, [fetchRecordsBySourceForSelectedType, recordTypes, users, dateRange, sourceType, page]);

  return (
    <>
      <ListModalForCharts
        chartType={chartType}
        onHide={onHide}
        onPageChange={setPage}
        page={page}
        pageSize={pageSize}
        records={recordsBySourceListData}
        title={title}
        totalRecords={totalRecords}
      />
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  recordsBySourceListData: getRecordsBySourceList(state),
  totalRecords: getTotalrecordsBySourceList(state),
});

const mapDispatchToProps = {
  fetchRecordsBySourceForSelectedType: fetchRecordsBySourceForSelectedType.request,
};

export default connect(mapStateToProps, mapDispatchToProps)(RecordListBySourceModal);
